/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_AppointmentsInputs */

const en_nav_appointments = /** @type {(inputs: Nav_AppointmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appointments`)
};

/**
* | output |
* | --- |
* | "Appointments" |
*
* @param {Nav_AppointmentsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_appointments = /** @type {((inputs?: Nav_AppointmentsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_AppointmentsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_appointments(inputs)
});